import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
var SaveDraft = function (_a) {
    var sendCampaign = _a.sendCampaign, disabled = _a.disabled;
    return (_jsx("button", { className: "c-btn c-btn--medium medium-and-up-ph+", onClick: function () { return sendCampaign(false); }, type: "button", disabled: disabled, children: "Review & Send" }));
};
SaveDraft.propTypes = {
    sendCampaign: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};
export default SaveDraft;
